import Notification from "@/services/echo-manager/notification";
import {useMainStore} from "@/store";

export default class AbilityPointsUpdated extends Notification
{
    handle() {
        useMainStore().UPDATE_ABILITY_POINTS(this.message.data);
    }
}
